import { render, staticRenderFns } from "./CustomPayment-60-Amba.vue?vue&type=template&id=688fd26b&scoped=true&"
import script from "./CustomPayment-60-Amba.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-60-Amba.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-60-Amba.vue?vue&type=style&index=0&id=688fd26b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688fd26b",
  null
  
)

export default component.exports